import { Pagination, Stack } from '@mui/material';
import React, { FC } from 'react';

interface IPolicyListPaginationProps {
	numberOfListItems: number;
	onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
	page: number;
	pageSize: number;
}

const PolicyListPagination: FC<IPolicyListPaginationProps> = ({ onChange, numberOfListItems, page, pageSize }) => {
	if (numberOfListItems <= pageSize) return null;

	const pageCount = Math.ceil(numberOfListItems / pageSize);

	return (
		<Stack spacing={2}>
			<Pagination
				count={pageCount}
				page={page}
				variant='outlined'
				color='secondary'
				size='large'
				shape='rounded'
				onChange={onChange}
				sx={{
					display: 'flex',
					justifyContent: 'center',
					padding: '2rem',
				}}
			/>
		</Stack>
	);
};

export default PolicyListPagination;
